import { z } from 'zod';

export const shortCodeParamSchema = z.object({
    shortCode: z.string(),
});

export const byStudentsQuerySchema = z.object({
  studentIds: z.string().optional(),
});
